/// <reference path="../../../../../../shared/utils/View.ts"/>
/// <reference path="../../../app.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/MitgliedschaftAnlageResponseApi.d.ts"/>

import { AppViewService } from '../../services/AppViewService';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppErrorService } from '../../services/AppErrorService';
import { AppApplicationService } from '../../services/AppApplicationService';
import { ConfirmationPageController } from "./ConfirmationPageController";
import { AppModelAdapter } from '../../helper/AppModelAdapter';
import { AppValidationService } from '../../services/AppValidationService';
import { User } from "../../../../../../shared/models/api/User/User";
import { BankAccountService } from '../../../../../../shared/services/BankAccountService';
import { CaptchaService } from '../../../../../../shared/services/CaptchaService';
import { AppApiService } from '../../services/AppApiService';
import { AppRateService } from '../../services/AppRateService';
import { SimulationTypeApi } from '../../../../../../shared/models/generated/TypesSimulationTypeApi';
import { CooperationService } from "../../../../../../shared/services/CooperationService";
import { ContractInfo } from '../../../../../../shared/models/api/User/ContractInfo';
import { EcommerceOrderStatus } from '../../../../../../shared/enums/EcommerceOrderStatus';
import { EcommerceProductStatus } from '../../../../../../shared/enums/EcommerceProductStatus';
import { AppApplicationModel } from '../../models/AppApplicationModel';
import { ApplicationPages } from '../../Constants';
import { AdvertisingConsentModel } from '../../../../../../shared/models/view/AdvertisingConsent';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { AppUtils } from '../../../../../../shared/utils/index';
import { AppFormModel } from '../../models/AppFormModel';

export class CheckPageController implements StepController {
	private readonly parent: AppController;
	private readonly user: User;
	private readonly options: MglModularSystemV2AppOptions;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appViewService: AppViewService;
	private readonly bankAccountService: BankAccountService;
	private readonly appApiService: AppApiService;
	private readonly appErrorService: AppErrorService;
	private readonly cooperationService: CooperationService<MglModularSystemV2AppDefinition>;
	private readonly applicationRouter: BasicApplicationRouter<MglModularSystemV2AppDefinition>;
	private readonly appApplicationService: AppApplicationService;
	private readonly appRateService: AppRateService;
	private captchaService: CaptchaService;
	private appValidationService: AppValidationService;
	private userIp: string;
	private advertisingConsentConfig: { version: string, trackingVersion: string, companyIdentifier: string, companyIdentifierReferenceCode: string, trackingReferenceId: string };

	constructor(parent: AppController, options: MglModularSystemV2AppOptions, user: User, loader: BasicLoader<MglModularSystemV2AppDefinition>) {
		this.parent = parent;
		this.options = options;
		this.user = user;

		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(options, loader);
		this.appApiService = new AppApiService(options);
		this.appErrorService = new AppErrorService(options);
		this.appApplicationService = new AppApplicationService(options);
		this.bankAccountService = new BankAccountService(options, user);
		this.appRateService = new AppRateService(options);
		if (this.options.app.iscooperation) {
			this.cooperationService = new CooperationService(options);
		}
		if (this.options.app.hasfdlmodule) {
			this.applicationRouter = new BasicApplicationRouter<MglModularSystemV2AppDefinition>(options);
		}
	}

	public start(): void {
		this.appApiService.getUserIpAdress(this.onIpSuccess.bind(this), this.startRendering.bind(this));
	}

	private onIpSuccess(userIp: { IP: string }): void {
		this.userIp = userIp.IP;
		this.startRendering();
	}

	private startRendering(): void {
		const viewConfig = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			parent: this,
			$ctx: this.options.$ctx,
			callback: this.afterRenderApp,
			options: this.options
		};

		this.appViewService.render(viewConfig);
	}

	private pushEcommerceBasisPacket(appModel: AppApplicationModel): void {
		AppUtils.Helper.scheduleTask(async () => {
			let model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
			model = AppModelAdapter.updateEcommerceModel(model, appModel, this.options);

			model.productStatus = EcommerceProductStatus.CHECKOUT;
			model.checkOutStep = "2";

			await T.Utils.Tracking.setEcommerceModel(model);
			T.Utils.Tracking.push(model, T.Utils.Tracking.CHECKOUT, T.Utils.Tracking.PIWIK_ONLY);
		}, 'background');
	}

	private submitEnclosure(ev: Event): void {
		ev.preventDefault();
		if (this.appValidationService.isValid() && (!this.options.app.hascaptchacode || this.captchaService.isCaptchaValid())) {
			AppUtils.View.startLoader();
			const appModel = this.appPersistenceService.getApplicationModel();
			const advertisingConsent = this.appPersistenceService.getAdvertisingConsent();
			this.pushEcommerceBasisPacket(appModel);
			const bankdaten = this.bankAccountService.getBankApi();
			const requestModel = AppModelAdapter.getAnlageApi(appModel.FormModel, advertisingConsent, appModel.Tarif, bankdaten, this.options, true, false);
			AppModelAdapter.setMailContent(requestModel, this.appViewService.getMailText(), this.appViewService.getHtmlMailText(), this.appViewService.getSubject(), this.appViewService.getMailAttatchments());
			const recommendationData = this.appPersistenceService.getRecommendationData();
			if (recommendationData) {
				AppModelAdapter.setRecommendationDataToRequestModel(requestModel, recommendationData);

				const recommendationId = T.Utils.Helper.getUrlParameter('recommendation');
				if (recommendationId) {
					const req = AppModelAdapter.getRecommendationApplicationNoteApiModel(recommendationId);
					this.appApiService.submitRecommendationApplicationNote(req);
				}
			}

			const advertisingConsentModel = this.appPersistenceService.getAdvertisingConsent();

			this.appApiService.submitEnclosure(requestModel, advertisingConsentModel, this.submitSuccess.bind(this), this.submitFailed.bind(this), SimulationTypeApi.None);
		}

	}

	private submitSuccess(successResponse: ApiResponse<AnlageResponseApi>, textStatus: string, jqhxr: JQueryXHR): void {
		const appModel = this.appPersistenceService.getApplicationModel();

		const model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
		model.productStatus = EcommerceProductStatus.ORDER;
		model.orderStatus = EcommerceOrderStatus.CONFIRMED;

		const userData = {
			user_phone: `${appModel.FormModel.Antragssteller.TelefonVorwahl}${appModel.FormModel.Antragssteller.TelefonNummer}`,
			user_mail: appModel.FormModel.Antragssteller.Email
		};

		T.Utils.Tracking.push(model, T.Utils.Tracking.ORDER, undefined, userData);
		this._pushFormSentTracking();

		if (this.options.app.iscooperation) {
			const successCallback = (): void => {
				this.showConfirmationPage(successResponse);
			};
			const errorCallback = (): void => {
				this.appErrorService.handleError(jqhxr);
			};
			this.cooperationService.submitCooperationData(successCallback, errorCallback, this.appPersistenceService.getIdentifyingPersonalData());
		} else {
			this.showConfirmationPage(successResponse);
		}
	}

	private _pushFormSentTracking(): void {
		if (this.appViewService.hasSectionClubcard()) {
			const appModel = this.appPersistenceService.getApplicationModel();

			const formExit = {
				eventAction: 'form_sent',
				eventCategory: 'Formular',
				eventLabel: 'Formular erfolgreich übermittelt',
				product: 'ADAC Mitgliedschaft',
				productVariant: appModel.FormModel.DigitaleClubkarte ? 'E-Mail' : 'Post'
			};

			T.Utils.Tracking.pushData({
				eventData: formExit,
				event: 'form_sent'
			});
		}
	}

	private showConfirmationPage(successResponse: ApiResponse<AnlageResponseApi>): void {
		const confirmationPageOptions = this.appApplicationService.preparePageOptions(ApplicationPages.Confirmation);
		const confirmationPageController = new ConfirmationPageController(this.parent, confirmationPageOptions, this.user, successResponse);
		confirmationPageController.start();
	}

	private submitFailed(jqxhr: JQuery.jqXHR): void {
		const model = T.Utils.Tracking.getEcommerceModel(this.options.app.ecommercemodel.producttype);
		model.productStatus = EcommerceProductStatus.ORDER;
		model.orderStatus = EcommerceOrderStatus.FORWARDED;

		const appModel = this.appPersistenceService.getApplicationModel();
		const userData = {
			user_phone: `${appModel.FormModel.Antragssteller.TelefonVorwahl}${appModel.FormModel.Antragssteller.TelefonNummer}`,
			user_mail: appModel.FormModel.Antragssteller.Email
		};

		T.Utils.Tracking.push(model, T.Utils.Tracking.ORDER, undefined, userData);
		this._pushFormSentTracking();

		if (this.options.app.iscooperation && !this.appErrorService.isQualifiedError(jqxhr)) {
			this.cooperationService.submitCooperationData(function () { /* don't care */ }, function () { /* don't care */ }, this.appPersistenceService.getIdentifyingPersonalData());
		}

		if (jqxhr && jqxhr.status === 400) {
			if (jqxhr.responseJSON) {
				const messages = jqxhr.responseJSON.Messages as Array<AdacResultMessage>;

				if (!jqxhr.responseJSON.Data && messages.length > 0) {
					const hasCaptchaError = messages.some(msg => msg.Id === 347000);
					if (hasCaptchaError) {
						this.appViewService.showErrorDialog(
							this.appValidationService.getMappedBackendMessage('347000'),
							this.onCloseCaptchaError.bind(this)
						);
						AppUtils.View.stopLoader();
						return;
					}
				}
			}
			if (this.options.app.hasfdlmodule) {
				this.applicationRouter.routeToLocation(this.options.app.errorpageurl);
			} else {
				this.appErrorService.handleError(jqxhr);
			}
		} else {
			this.appErrorService.handleTechnicalErrorWithErrorTemplate(jqxhr, true);
			this.appPersistenceService.clearApplicationSession();
			if (this.options.app.iscooperation) {
				this.cooperationService.clearSession();
			}
		}
		T.Utils.View.stopLoader();
	}

	private onCloseCaptchaError(): void {
		this.appPersistenceService.clearApplicationSession();
	}

	/**
	 * returns view options for calculator page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): object {
		const appModel = this.appPersistenceService.getApplicationModel();
		const bankdaten = this.bankAccountService.getBankdaten();
		const cooperationModel = this.options.app.iscooperation ? this.cooperationService.getDynamicFieldsFromStore() : {};
		const isFutureMglBegin = moment(appModel.FormModel.MitgliedschaftStartDatum).month() > moment().month();
		const advertisingData = this.appPersistenceService.getFriendsAdvertisingDataFromStorage();

		appModel.FormModel.Kinder.sort((childA, childB) => {
			return (childA.IsJuv === childB.IsJuv) ? 0 : childA.IsJuv ? -1 : 1;
		});
		const advertisingKey = appModel.FormModel.Werbeschluessel ? appModel.FormModel.Werbeschluessel : (this.options.app.advertisingkey ? Number(this.options.app.advertisingkey) : undefined);
		const showDigitalClubcard = appModel.FormModel.Partner === undefined && appModel.FormModel.Kinder.length === 0 && (advertisingKey === 7001 || advertisingKey === 1076);

		return {
			FormModel: appModel.FormModel,
			Antragssteller: appModel.FormModel.Antragssteller,
			Partner: appModel.FormModel.Partner,
			Kinder: appModel.FormModel.Kinder,
			User: this.user,
			Tarif: appModel.Tarif,
			TarifBeschreibung: ContractInfo.getDescription(this.options.app.ratenamemappings, appModel.Tarif.TarifCodeId),
			Beitrag: appModel.Tarif.Beitrag,
			productActiveModel: advertisingData.productActiveModel,
			hasCopayment: this.appPersistenceService.hasCopayment(),
			isCashItem: advertisingData.productIsCashItem,
			isCheckPage: true,
			hasCaptcha: this.options.app.hascaptchacode,
			IsFutureMglBegin: isFutureMglBegin,
			Bankdaten: bankdaten,
			iscooperation: this.options.app.iscooperation !== undefined ? this.options.app.iscooperation : false,
			CooperationModel: cooperationModel,
			ratechangeurl: this.options.app.ratechangeurl,
			hidelegalnotice: this.options.app.hidelegalnotice,
			IsYoungGenerationNoviceDriverLicense: AppModelAdapter.isYoungGenerationNoviceDriverLicense(appModel.Tarif.TarifCode),
			IsYoungGenerationRate: AppModelAdapter.isYoungGenerationRate(this.options.app.rate),
			Bonus: appModel.FormModel.Bonus,
			IP: this.userIp,
			showDigitalClubcard: showDigitalClubcard
		};
	}

	public afterRenderApp(): void {
		T.Utils.Tracking.pushKameleoonData();
		this.appValidationService = new AppValidationService({ options: this.options }, $(this.options.$ctx).find(`#${this.options.app.applicationId} form`));

		this.captchaService = new CaptchaService(
			() => this.appPersistenceService.getFormModelFromStore(),
			(model: AppFormModel) => this.appPersistenceService.setFormModelToStore(model),
			(disabled: boolean) => this.appViewService.toggleSubmitButton(disabled)
		);

		this.captchaService.registerCaptchaHandler($(this.options.$ctx).find(`#${this.options.app.applicationId}`));

		const mglApp = this.appPersistenceService.getApplicationModel();
		mglApp.Step = this.options.app.currenttemplate.step;

		this.advertisingConsentConfig = this.appViewService.getAdvertisingConsentConfig();
		mglApp.FormModel.Werbetext = this.appViewService.getAdverstingTextFromView();
		mglApp.FormModel.AdvertisingVersion = this.advertisingConsentConfig.version;

		let advertisingConsent = this.appPersistenceService.getAdvertisingConsent();
		advertisingConsent = this.enrichAdvertisingModel(advertisingConsent);
		this.appPersistenceService.setAdvertisingConsent(advertisingConsent);

		this.appPersistenceService.setApplicationModel(mglApp);

		this.parent.afterRenderApp();

		this.appViewService.addCheckListeners(
			this.onViewChanged.bind(this),
			this.backLinkListener.bind(this),
			this.submitEnclosure.bind(this),
			this.captchaHandler.bind(this)
		);
		this.appViewService.showCommercialNotice();


		this.appRateService.updateRate(true);

		AppUtils.View.scrollTop();
	}

	private captchaHandler(ev: Event): void {
		const customEvent = ev as CustomEvent<{ solution: string }>;
		const formModel = this.appPersistenceService.getFormModelFromStore();

		formModel.Validierungscode = customEvent.detail.solution;
		this.appPersistenceService.setFormModelToStore(formModel);
		this.appViewService.toggleSubmitButton(false);
	}

	private backLinkListener(ev: Event): void {
		ev.preventDefault();
		const mglApp = this.appPersistenceService.getApplicationModel();
		mglApp.Step = 0;
		this.appPersistenceService.setApplicationModel(mglApp);
		location.reload();
	}

	private onViewChanged(): void {
		AppUtils.Helper.scheduleTask(() => {
			if (this.appValidationService.isValidWithoutTriggerErrors()) {
				const appModel = this.appPersistenceService.getApplicationModel();
				this.appViewService.updateLegalValues(appModel.FormModel);
				this.appViewService.updateWerbeZustimmungModel(appModel.FormModel);
				this.appViewService.updateDigitalClubcardValues(appModel.FormModel);
				let advertisingConsent = this.appViewService.getAdvertisingConsentModel(this.userIp);
				advertisingConsent = this.enrichAdvertisingModel(advertisingConsent);
				this.appPersistenceService.setAdvertisingConsent(advertisingConsent);
				this.appPersistenceService.setFormModelToStore(appModel.FormModel);
			}
		}, 'user-visible');
	}

	private enrichAdvertisingModel(advertisingConsentModel: AdvertisingConsentModel): AdvertisingConsentModel {
		advertisingConsentModel.CompanyIdentifier = this.advertisingConsentConfig.companyIdentifier;
		advertisingConsentModel.CompanyIdentifierReferenceCode = this.advertisingConsentConfig.companyIdentifierReferenceCode;
		advertisingConsentModel.TrackingConsentVersion = this.advertisingConsentConfig.trackingVersion;
		advertisingConsentModel.TrackingReferenceId = this.advertisingConsentConfig.trackingReferenceId;

		return advertisingConsentModel;
	}
}
